import React, {useEffect, useState} from 'react';
import TopTitleBlock from '../../../Components/TopTitleBlock/TopTitleBlock';
import s from './MainLessons.module.css';
import link from '../../../assets/img/icons/Lessons/ep_link.svg';
import OneLessonElement from './OneLessonElement';
import {Link, useParams} from 'react-router-dom';
import 'swiper/css/scrollbar';
import LightGreenButton from '../../../Components/Buttons/LightGreenButton';
import '../../../swiperStyles.css';
import EducationBackButton from '../../../Components/Buttons/EducationBackButton';
import MainEducationProgressLineTop from '../EducationComponents/MainEducationProgressLineTop';
import LessonAccordionTopComponent from './LessonAccordionTopComponent';
import {useDispatch, useSelector} from 'react-redux';
import {
	getOneLesson,
	getQuestions,
	getSendFeedback,
} from '../../../redux/education_Reducer';
import {RootState} from '../../../redux/store';
import {
	BlockLesson,
	DockLesson,
	SubLesson,
} from '../../../types/TypesEducation';
import TestLessonForm from './TestLessonForm';

const MainLessons: React.FC = () => {
	const dispatch: any = useDispatch();
	const apiData = useSelector((state: RootState) => state.appData.appData);
	const auth = useSelector((state: RootState) => state.userData.authData);
	const {lessonId} = useParams();
	const getMeLesson = useSelector(() => getOneLesson);
	const getMeQuestions = useSelector(() => getQuestions);
	const sendMyFeedback = useSelector(() => getSendFeedback);
	const lesson = useSelector(
		(state: RootState) => state.educationData.oneLesson,
	);
	const questions = useSelector(
		(state: RootState) => state.educationData.questions,
	);
	const userModuleNavigation = useSelector(
		(state: RootState) => state.educationData.userModuleNavigation,
	);
	const [textForSendFeedback, setTextForSendFeedback] = useState('');

	const handleGiveFeedback = (value: string) => {
		setTextForSendFeedback(value);
	};
	const sendFeedback = () => {
		if (textForSendFeedback !== '') {
			dispatch(sendMyFeedback(textForSendFeedback));
			setTextForSendFeedback('');
		}
	};
	useEffect(() => {
		if (auth && lessonId) {
			dispatch(getMeLesson(+lessonId));
			if (!lesson?.completed) {
				dispatch(getMeQuestions(+lessonId));
			}
		}
	}, [lessonId, auth]);
	/*if (!apiData.response || apiData.response.length <= 0) {
           //return <Navigate to={'/main_education'} />;
       }*/

	let nav_path = apiData.text_education;
	if (lesson) {
		nav_path += ' > ' + lesson?.name;
	}
	if (userModuleNavigation && userModuleNavigation.length > 0) {
		nav_path = '';
		userModuleNavigation?.map((navigation: any, index: number) => {
			nav_path += (index ? ' > ' : '') + navigation.name;
		});
	}
	return (
		<main className={`${s.lessonsMain} page`}>
			<div className="container">
				<div className={s.titleBlockWrapper}>
					<TopTitleBlock pagination={nav_path} />
					<EducationBackButton />
				</div>
				<div className={s.titleLesson}>
					<h3>{lesson?.fullname}</h3>
				</div>
				<div className={s.contentContainer}>
					{lesson && (
						<MainEducationProgressLineTop
							text={apiData?.response?.lesson?.text ?? ''}
							img={lesson.img_banner}
							name={lesson.name}
							progress={lesson.progress}
							completed={lesson.completed}
						/>
					)}
					{/* Boolean(apiData.response.lesson) && Boolean(apiData.response.lesson.sublessons[0]) && <EducationModules title={''} link={'/lesson/'} subModules={apiData.response.lesson.sublessons} textAccess={apiData.text_Access} textAccessDenied={apiData.text_accessDenied} textNotAvailable={apiData.text_notAvailable} textOneMoreTime={apiData.text_OneMoreTime} /> */}
				</div>
				{lesson?.blockslesson?.map(
					(blockslesson: BlockLesson, index: number) => {
						return (
							<div key={`blockslesson ${index}`}>
								<OneLessonElement
									type={blockslesson.typeblock}
									html={blockslesson.html_text}
								/>
							</div>
						);
					},
				)}
				{lesson?.docslesson && (
					<div className={s.materialsForLessons}>
						<div className={s.materialsForLessonsTitle}>
							{apiData?.text_docs_lesson}
						</div>
						{lesson?.docslesson?.map((doclesson: DockLesson, index: number) => (
							<div
								key={`blockslesson${index}`}
								className={s.materialsForLessonsLinks}
							>
								<div
									key={`docslesson${doclesson?.href}`}
									className={s.linksColumn}
								>
									<Link to={doclesson?.href}>
										<img src={link} alt="link" />
										{doclesson?.name}
									</Link>
								</div>
							</div>
						))}
					</div>
				)}
				{Array.isArray(lesson?.sublessons) &&
					lesson?.sublessons[0] !== null && (
						<>
							<div className={s.titleLesson}>
								<h3>{apiData.text_select_lesson}</h3>
							</div>
							<ul className={s.lessonsListContainer}>
								{lesson?.sublessons?.map(
									(sublesson: SubLesson, index: number) => {
										return (
											<li
												key={`blockslesson3${sublesson.name}`}
												className={s.lessonContainer}
											>
												<LessonAccordionTopComponent
													title={
														apiData.text_education_lesson +
														' ' +
														(index + 1) +
														' ' +
														sublesson.name
													}
													open={true}
												/>
												<div className={s.lessonContent}>
													{sublesson?.blockslesson?.map(
														(blockslesson2: BlockLesson) => {
															return (
																<div
																	key={`blockslesson2${blockslesson2.typeblock}`}
																>
																	<OneLessonElement
																		type={blockslesson2.typeblock}
																		html={blockslesson2.html_text}
																	/>
																</div>
															);
														},
													)}
												</div>
											</li>
										);
									},
								)}
							</ul>
						</>
					)}
				{/*{questions &&
                    <form action={'/user/study-complete'} id={'study-complete'} onSubmit={postSubmit}>
                        <div className={s.tasksContainer}>
                            <div className={`${s.planPlan} page__plan plan`}>
                                <div className="plan__title">{apiData.text_questions}</div>
                                <div className="plan__top">
                            <div className="plan__date">001</div>
                            <div className="plan__divider">---</div>
                            <div className="plan__date">006</div>
                        </div>
                        <div className={`${s.planText} plan__text`}>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Amet, velit facilisi viverra mattis
                            ultricies bibendum rhoncus.
                        </div>
                            </div>
                            <div className={`${s.sliderContainer} page__marketing-slider slider-marketing`}>
                                <div className={`${s.sliderWrapper} slider-marketing__wrapper`}>
                                    <Swiper
                                        modules={[FreeMode, Scrollbar, Mousewheel]}
                                        direction={"vertical"}
                                        slidesPerView={questions.length}
                                        spaceBetween={0}
                                        loop={false}
                                        scrollbar={{draggable: true, dragSize: 24}}
                                        mousewheel={true}
                                        className={'mainLessons'}
                                    >
                                        {questions?.map((question: QuestionType) => {
                                            return (
                                                <div key={`questiontitle${question.question_id?? + Math.random()}`}>
                                                    <SwiperSlide className="slider-marketing__slide">
                                                        <TaskQuestionElement title={question.title}
                                                                             answers={question?.answers}
                                                                             question_id={question.question_id}/>
                                                    </SwiperSlide>
                                                </div>
                                            )
                                        })}
                                    </Swiper>
                                </div>
                            </div>
                        </div>
                        {Boolean(apiData.response.lesson) &&
                            <input type={"hidden"} name={'lesson_id'} value={apiData.response.lesson.lesson_id}/>}
                        <div className={s.buttonWrapper}>
                            <VeryLightGreenButton text={apiData.text_set_lesson}/>
                        </div>
                    </form>
                }*/}
				{questions && !lesson?.completed && lesson?.lesson_id && (
					<TestLessonForm
						text_set_lesson={apiData.text_set_lesson}
						questions={questions}
						lessonId={lesson.lesson_id}
						text_questions={apiData.text_questions}
					/>
				)}
				{/*{textApproveFeedback !=="" &&
                    <div>{textApproveFeedback}</div>}*/}
				<form>
					<div className={s.commentContainer}>
						<div className={s.commentTitle}>{apiData.text_set_feedback}</div>
						<div className={s.commentInput}>
							<textarea
								name={'feedback'}
								placeholder={apiData.text_set_text}
								value={textForSendFeedback}
								onChange={(event) =>
									handleGiveFeedback(event.currentTarget.value)
								}
							/>
						</div>
						<div className={s.commentButton}>
							<LightGreenButton
								text={apiData.text_sendSmsButton}
								onClick={sendFeedback}
								type={'button'}
							/>
						</div>
					</div>
				</form>
			</div>
		</main>
	);
};

export default MainLessons;
